/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export function useQuery() {
  return queryString.parse(useLocation().search);
}
